import { PropsWithChildren } from "react";
import { Anchor, AnchorProps, Text, TextProps } from "@mantine/core";
import Linkify from "linkify-react";

export function AutoLink(props: { textProps?: TextProps, anchorProps?: AnchorProps } & PropsWithChildren) {
    const renderLink = ({ attributes, content }: Record<string, any>) => {
        const { href, ..._props } = attributes;
        return <Anchor href={href} target="_blank" {..._props} {...props.anchorProps}>{content}</Anchor>;
    };
    return (
        <Text style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }} {...props.textProps}>
            <Linkify options={{
                render: renderLink
            }}>
                {props.children}
            </Linkify>
        </Text>
    );
}